import React, { useState } from 'react';
import { BASE_URL } from '../config/api';
import { useNavigate } from 'react-router-dom';

const AddFlash = () => {
    const [flashData, setFlashData] = useState({
        staff_id: 1,
        customer_name: '',
        pcs: '',
        gross_weight: '',
        description: '',
    });
    const navigate = useNavigate();

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFlashData((prevData) => ({
            ...prevData,
            [name]: value,
        }));
    };

    const handleSubmit = (e) => {
        e.preventDefault();

        fetch(`${BASE_URL}flashes`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(flashData),
        })
            .then(response => response.json())
            .then(data => {
                if (data.status === 1) {
                    navigate('/FlashesList');
                } else {
                    alert('Error adding flash: ' + data.message);
                }
            })
            .catch(error => {
                console.error('Error:', error);
                alert('Error adding flash');
            });
    };

    return (
        <div id="main">
            <header className="mb-3">
                <a href="#" className="burger-btn d-block d-xl-none">
                    <i className="bi bi-justify fs-3"></i>
                </a>
            </header>

            <div className="page-heading">
                <div className="page-title">
                    <div className="row">
                        <div className="col-12 col-md-6 order-md-1 order-last">
                            <h3>Add Flash</h3>
                        </div>
                    </div>
                </div>
            </div>

            <section className="section">
                <div className="row">
                    <div className="col-12 col-md-12">
                        <div className="card">
                            <div className="card-body">
                                <form onSubmit={handleSubmit}>
                                    <div className="mb-3">
                                        <label htmlFor="customerName" className="form-label">Customer Name</label>
                                        <input
                                            type="text"
                                            id="customerName"
                                            name="customer_name"
                                            className="form-control"
                                            value={flashData.customer_name}
                                            onChange={handleChange}
                                            required
                                        />
                                    </div>
                                    <div className="mb-3">
                                        <label htmlFor="pcs" className="form-label">PCS</label>
                                        <input
                                            type="number"
                                            id="pcs"
                                            name="pcs"
                                            className="form-control"
                                            value={flashData.pcs}
                                            onChange={handleChange}
                                            required
                                        />
                                    </div>
                                    <div className="mb-3">
                                        <label htmlFor="grossWeight" className="form-label">Gross Weight</label>
                                        <input
                                            type="number"
                                            id="grossWeight"
                                            name="gross_weight"
                                            className="form-control"
                                            value={flashData.gross_weight}
                                            onChange={handleChange}
                                            required
                                        />
                                    </div>
                                    <div className="mb-3">
                                        <label htmlFor="description" className="form-label">Description</label>
                                        <textarea
                                            id="description"
                                            name="description"
                                            className="form-control"
                                            value={flashData.description}
                                            onChange={handleChange}
                                            required
                                        ></textarea>
                                    </div>
                                    <div className="text-end">
                                        <button type="submit" className="btn btn-primary">Add Flash</button>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </div>
    );
};

export default AddFlash;
